import { gql } from '@apollo/client';

export const UPSERT_DECLARATION = gql`
  mutation upsertDeclaration($input: UpsertDeclarationInput!) {
    declaration: upsertDeclaration(input: $input) {
      id
    }
  }
`;
